// 辣友會落地頁 /chiliclub（GTM 30 日清單 #1）
// ⚠️ 未上線（chiliclub_live=0）：顯示權益＋「即將開放」；join 按鈕禁用。
// 無 popup label、robots Disallow——Captain 拍板 go live 先解除。
import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { apiFetch, SITE_URL } from '../lib/api';

interface ClubStatus { live: boolean; taken: number; capacity: number }

const RED = '#d9381e';

const BENEFITS = [
  { icon: '🌶️', title: '每月辣中聖品寄到屋企', desc: '月月唔同主題——隱藏口味／限量聯乘，多巴胺期待迴路' },
  { icon: '🏪', title: '全港合作商家專屬優惠', desc: '會員卡＝辣店通行證，到店出示即刻享（商家網絡持續擴張）' },
  { icon: '👥', title: '會員專屬 WhatsApp 群組', desc: '結識同樣愛辣嘅朋友——由食客變辣友' },
  { icon: '🎉', title: '季度聚會＋嘗新活動', desc: '會員帶一位朋友，現場入會享限定禮' },
  { icon: '🎯', title: '季度辣任務', desc: '晒開箱 tag #辣友會——完成者下季配送加料' },
  { icon: '🪪', title: '創會會籍卡刻名', desc: '首 100 席＝創會會員，永久鎖定 HK$99/年' },
];

const Chiliclub: React.FC = () => {
  const navigate = useNavigate();
  const [status, setStatus] = useState<ClubStatus | null>(null);
  const [name, setName] = useState('');
  const [phone, setPhone] = useState('');
  const [busy, setBusy] = useState(false);
  const [msg, setMsg] = useState<string | null>(null);

  useEffect(() => {
    apiFetch('/api/public/chiliclub').then(async (res) => {
      try { setStatus((await res.json()).data ?? null); } catch { /* ignore */ }
    }).catch(() => {});
  }, []);

  const join = async () => {
    if (busy) return;
    setMsg(null);
    setBusy(true);
    try {
      const res = await apiFetch('/api/public/chiliclub/join', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ name, phone, refCode: new URLSearchParams(window.location.search).get('r') || '' }) });
      const json = await res.json().catch(() => ({}));
      if (!res.ok) { setMsg(json.error || '報名失敗，請稍後再試'); return; }
      const orderNum = json.data?.orderNum || json.orderNum;
      // 行既有 KPay checkout→收銀台
      const pay = await apiFetch(`/api/public/orders/${encodeURIComponent(orderNum)}/kpay/checkout`, { method: 'POST' });
      const payJson = await pay.json().catch(() => ({}));
      const cashierUrl = payJson.data?.cashierUrl || payJson.cashierUrl;
      if (pay.ok && cashierUrl) {
        window.location.href = cashierUrl;
        return;
      }
      setMsg(payJson.error || '支付通道暫時未能連接，請稍後再試');
    } catch {
      setMsg('網絡異常，請稍後再試');
    } finally {
      setBusy(false);
    }
  };

  const seatsLeft = status ? Math.max(0, status.capacity - status.taken) : null;

  return (
    <div className="min-h-screen bg-[#0a0a0a] text-stone-200">
      <div className="mx-auto max-w-2xl px-4 py-10">
        <header className="text-center">
          <p className="text-[10px] font-bold uppercase tracking-[0.3em] text-stone-500">香港辣谷・辣友會</p>
          <h1 className="mt-3 text-3xl font-black leading-tight sm:text-4xl">
            🌶️ 辣友會——<span style={{ color: RED }}>香港辣文化的會籍</span>
          </h1>
          <p className="mx-auto mt-3 max-w-lg text-sm leading-relaxed text-stone-400">
            這不是購買折扣，而是購買身份：每月辣中聖品驚喜、全港合作商家專屬優惠、結識同樣愛辣的朋友。
            <span className="ml-1 font-bold text-stone-200">HK$99/年</span>
          </p>
          {seatsLeft !== null && (
            <p className="mt-2 text-xs font-bold" style={{ color: RED }}>
              創會席位：剩 {seatsLeft}／{status?.capacity}（會籍卡刻名＋永久鎖定年費）
            </p>
          )}
        </header>

        {/* 權益表 */}
        <section className="mt-8 grid gap-3 sm:grid-cols-2">
          {BENEFITS.map((b) => (
            <div key={b.title} className="rounded-2xl bg-white/5 p-4 ring-1 ring-white/10">
              <p className="text-2xl">{b.icon}</p>
              <h2 className="mt-1 text-base font-black text-stone-100">{b.title}</h2>
              <p className="mt-1 text-xs leading-relaxed text-stone-400">{b.desc}</p>
            </div>
          ))}
        </section>

        {/* 報名 */}
        <section className="mt-8 rounded-2xl bg-white/5 p-5 ring-1 ring-white/10">
          {status?.live ? (
            <>
              <h2 className="text-lg font-black text-stone-100">創會會員報名</h2>
              <div className="mt-3 space-y-2">
                <input value={name} onChange={(e) => setName(e.target.value)} placeholder="姓名"
                  className="w-full rounded-lg border border-white/10 bg-black/30 px-3 py-2.5 text-sm text-stone-100 outline-none focus:border-red-500" />
                <input value={phone} onChange={(e) => setPhone(e.target.value)} placeholder="聯絡電話（852…）" inputMode="tel"
                  className="w-full rounded-lg border border-white/10 bg-black/30 px-3 py-2.5 text-sm text-stone-100 outline-none focus:border-red-500" />
                <button onClick={join} disabled={busy || !name || !phone}
                  className="w-full rounded-lg py-3 text-sm font-black text-white disabled:opacity-40"
                  style={{ background: RED }}>
                  {busy ? '處理中…' : `💳 KPay 一鍵入會 HK$99/年`}
                </button>
                {msg && <p className="text-center text-xs text-red-400">{msg}</p>}
              </div>
            </>
          ) : (
            <div className="text-center">
              <h2 className="text-lg font-black text-stone-100">會籍即將開放 🌶️</h2>
              <p className="mx-auto mt-2 max-w-md text-xs leading-relaxed text-stone-400">
                創會招募準備中——種子池成員將比公開早 7 日收到邀請。
                想知成個部署安排，睇吓我哋嘅行動計劃簡報。
              </p>
              <div className="mt-4 flex flex-wrap justify-center gap-2">
                <a href={`${SITE_URL}/chilifans`} className="rounded-lg px-4 py-2 text-xs font-bold text-white" style={{ background: RED }}>🗺️ 睇行動計劃簡報</a>
                <a href={`${SITE_URL}/store`} className="rounded-lg bg-white/10 px-4 py-2 text-xs font-bold text-stone-200">🛍️ 照樣去商店掃貨</a>
              </div>
              {msg && <p className="mt-3 text-xs text-red-400">{msg}</p>}
            </div>
          )}
        </section>

        <p className="mt-8 text-center text-xs text-stone-600">香港🌶️辣谷 HKSpicyValley.com · <button onClick={() => navigate('/terms')} className="underline">條款</button></p>
      </div>
    </div>
  );
};

export default Chiliclub;
